import { QueryHookOptions, useQuery } from '@apollo/client';
import query from '../../queries/vehicleModelDetails';
import { VehicleSpec } from './useVehicleModels';

export interface VehicleImage {
  code: string;
  images: string[];
}
export interface VehicleOptionAssetsItem {
  code: string;
  title: string;
  tileImage: string;
  images: string[];
  imageSets: VehicleImage[];
  exteriorImages: VehicleImage[];
  specs?: VehicleSpec[]; 
}
export interface VehicleOptionAssets {
  categoryCode: string;
  categoryName: string;
  typeCodes: string[];
  typeValues: VehicleOptionAssetsItem[];
  configuredOption?: VehicleOptionAssetsItem;
}
export interface ExteriorAssets {
  color: VehicleOptionAssets;
  features?: VehicleSpec[];
}
export interface InteriorAssets {
  color: VehicleOptionAssets;
  features?: VehicleSpec[];
}

export interface VehicleConfigurationAssets {
  version: string;
  locale: string;
  title: string;
  expectAvailableDate: string;
  exterior: ExteriorAssets;
  wheel: VehicleOptionAssets;
  interior: InteriorAssets;
}

export interface VehicleOverviewAssets {
  version: string;
  locale: string;
  id: string;
  title: string;
  model: string;
  edition: string;
  expectAvailableDate: string;
  overviewFeatures: [VehicleSpec]
  overviewSpecs: [VehicleSpec]
}

export interface VehicleModelDetails {
  active: boolean;
  assetPath: string;
  basePrice: number;
  brand: string;
  depositAmount: number;
  preorderDepositAmount: number;
  edition?: string;
  id: number;
  isWaitlistAllowed: boolean;
  model: string;
  name: string;
  region: 'NA' | 'CN';
  reserveSpotCap?: number;
  vehicleMarketStatusDesc: string;
  year: string;
  fullModelCode: string;
  vehicleOverviewAssets: VehicleOverviewAssets;
  vehicleConfigurationAssets: VehicleConfigurationAssets;
}

interface UseVehicleModelDetailsResponse {
  vehicleModelDetails: VehicleModelDetails;
}

interface UseVehicleModelDetailsRequest {
  modelId: number;
}

export default function useVehicleModelDetails(
  modelId: number,
  options: QueryHookOptions<UseVehicleModelDetailsResponse, UseVehicleModelDetailsRequest> = {}
) {
  const { data, ...rest } = useQuery<
    UseVehicleModelDetailsResponse,
    UseVehicleModelDetailsRequest
  >(query, {
    ...options,
    variables: {
      modelId
    }
  });

  const vehicleModelDetails = data?.vehicleModelDetails;

  return {
    vehicleModelDetails,
    ...rest
  };
}
